import { module } from 'modujs';
import { formDeserialize } from '../utils/html'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                input: 'onChange',
                reset: 'reset'
            }
        }

        this.selectedTerms = []
        this.form = this.$('form')[0]
        this.filters = this.$('input')
        this.resetButton = this.$('reset')[0]
    }

    init() {
        this.submitBind = this.handleSubmit.bind(this)
        this.form.addEventListener('submit', this.submitBind)

        this.setFormData()
    }

    /**
     * Set form data
     * Will apply data on a form from url params
     *
     */
    setFormData() {
        const url = new URL(window.location.href)
        if(url.search) {
            formDeserialize(this.form, url.search)
            Array.prototype.forEach.call(this.filters, (filter) => {
                if (filter.querySelector('input').checked) this.activateFilter(filter)
            })
        } else {
            this.activateFilter(this.resetButton)
        }
    }

    /**
     * Handle sumbit and query parameters
     * ⚠️ Won't work on IE11
     *
     * @param {event}
     */
    handleSubmit() {
        let url = window.location.href;

        // Retrieve FormData
        const formData = new FormData(this.form);

        // Clear empty fields from FormData
        for (const entry of Array.from(formData.entries())) {
            if(!entry[1] || entry[0] === 'all') {
                formData.delete(entry[0])
            }
        }

        // Create parameters string
        const parametersString = new URLSearchParams(formData).toString();

        // Construct final URL
        const queryUrl = (parametersString.length > 0) ? `${url.split('?')[0]}?${parametersString}` : url.split('?')[0]

        // Launch transition
        this.call('goTo', { url: queryUrl, transition: 'list' }, 'Load')
    }

    onChange(e) {
        e.preventDefault()

        const target = e.target
        const term = target.name

        // Toggle button style
        target.parentNode.classList.toggle('is-active')

        // Count how many selected terms
        if (target.checked) {
            this.selectedTerms.push(term)
        } else {
            this.selectedTerms.splice(this.selectedTerms.indexOf(term), 1)
        }

        // Activate / Deactivate "reset" filter (all)
        if (this.selectedTerms.length === 0) {
            this.activateFilter(this.resetButton)
        } else if (this.resetButton.classList.contains('is-active')) {
            this.deActivateFilter(this.resetButton)
        }

        this.handleSubmit()
    }

    reset() {
        this.activateFilter(this.resetButton)
        Array.prototype.forEach.call(this.filters, (filter) => this.deActivateFilter(filter))
        this.handleSubmit()
    }

    activateFilter(filter) {
        if (filter.classList.contains('is-active')) return
        filter.classList.add('is-active')
        filter.querySelector('input').checked = true
    }

    deActivateFilter(filter) {
        if (!filter.classList.contains('is-active')) return
        filter.classList.remove('is-active')
        filter.querySelector('input').checked = false
    }
}
